import { useRef, useState, useEffect } from "react"
import EditIcon from '../../../../../assets/images/icons/edit.svg';

export const EditableTrackName = ({ demo, name, onSave }) => {
    const [isEditing, setIsEditing] = useState(false)
    const [editValue, setEditValue] = useState(name)
    const inputRef = useRef(null)

    useEffect(() => {
        if (isEditing && inputRef.current) {
            inputRef.current.focus()
            inputRef.current.select()
        }
    }, [isEditing])

    const handleSave = () => {
        if (editValue.trim()) {
            onSave(editValue.trim())
            setIsEditing(false)
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSave()
        } else if (e.key === 'Escape') {
            setEditValue(name)
            setIsEditing(false)
        }
    }

    if (isEditing) {
        return (
            <input
                ref={inputRef}
                type="text"
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                onBlur={handleSave}
                onKeyDown={handleKeyDown}
                className="bg-black/25 text-white px-2 py-1 rounded border border-white/30 focus:outline-none focus:border-blue-500"
            />
        )
    }

    return (
        <div className="flex items-start max-w-[220px]">
            <span className="text-sm break-words break-all whitespace-normal max-w-full">
                {name}
            </span>

            <button
                disabled={demo}
                onClick={() => setIsEditing(true)}
                className="ml-2 mt-2 shrink-0 hover:opacity-70 transition-opacity"
            >
                <img
                    src={EditIcon}
                    alt="Edit Icon"
                    className="h-[14px] w-[14px] invert-[100%]"
                />
            </button>
        </div>
    )
}